module.exports = __webpack_public_path__ + "static/media/CeraPro-Bold.b4a266a7.woff2";